<template>
<div class="chapter">
<div class="inner_page">
<div class="ipadfp"><img alt="Cover: The Shimmering State, by Meredith Westgate" aria-describedby="cover-alt" class="imagefp" role="doc-cover" src="e9781982156732/images/9781982156732.jpg"/></div>
<aside hidden="hidden" id="cover-alt">
<p>“An impressive, unsettling, and surprisingly romantic debut.” —Helen Schulman, author of <i>Come with Me</i></p>
<p>The Shimmering State</p>
<p>A Novel</p>
<p>Meredith Westgate</p>
</aside>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// cover.vue?3a63449b